/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/* prettier-ignore */

import { ArtworkDto } from './ArtworkDto';
import { BlockchainAccountDto } from './BlockchainAccountDto';

export interface EditionDto {
    id: number;
    publicEditionNumber: number;
    tokenId?: number;
    createdAt: number;
    ownerAddress?: string;
    type: EditionDto.type;
    tah?: string;
    uid?: string;
    artwork?: ArtworkDto;
    owner?: BlockchainAccountDto;
}

export namespace EditionDto {

    export enum type {
        LIMITED_EDITION = 'limited-edition',
        HORS_DU_COMMERCE = 'hors-du-commerce',
        ARTIST_PROOF = 'artist-proof',
    }


}



// WEBPACK FOOTER //
// ./src/services/openapi/generated/models/EditionDto.ts